import { FC, ReactNode } from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';

interface Props {
  name: string;
  label?: ReactNode;
  maxLength?: number;
  disabled?: boolean;
  className?: string;
  rows?: number;
  minRows?: number;
  maxRows?: number;
  format?: (value: any) => string;
  parse?: (value: string) => any;
  placeholder?: string;
  validate?: any;
  customErrorValidation?: boolean;
}

export const TextAreaField: FC<Props> = ({
  label,
  maxLength = 100,
  name,
  disabled = false,
  className,
  rows = 4,
  minRows = 3,
  maxRows = 8,
  format,
  parse,
  placeholder,
  validate,
  customErrorValidation,
  ...props
}) => {
  return (
    <Field name={name} allowNull format={format} parse={parse} validate={validate} {...props}>
      {({ input, meta }) => (
        <div
          className={classNames('form-group', {
            'has-danger':
              ((meta.error || meta.submitError) && meta.touched) || customErrorValidation,
          })}
        >
          <div>
            {label && <label htmlFor={name}>{label}</label>}
            <textarea
              {...input}
              rows={rows}
              maxLength={maxLength}
              disabled={disabled}
              placeholder={placeholder}
              className={classNames('form-control', className)}
              style={{
                minHeight: `${minRows * 1.5}em`,
                maxHeight: `${maxRows * 1.5}em`,
                resize: 'vertical',
              }}
            />
            {(((meta.error || meta.submitError) && meta.touched) || customErrorValidation) && (
              <label htmlFor={name} className="error">
                {meta.error || meta.submitError}
              </label>
            )}
          </div>
        </div>
      )}
    </Field>
  );
};
